import React from "react";
import {
    FormikAutocompleteInput,
    FormikDateInput,
    FormikSelectInput,
    FormikTextInput,
} from "./FormikInputs";
import { FiltrosStyles } from "pages/Filtros.styles";
import { Button, HeaderButton } from "components";
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
export default function Filters({ formik, inputsRender, disabled, children, selectDefault }) {
    const styles = FiltrosStyles();
    return (
        <form className={styles.filtros} onSubmit={formik.handleSubmit}>
            {
                inputsRender.map((input, index) => (
                    <div key={index} className={styles.inputContainer}>
                        {
                            input.type.toLowerCase() === "text" && (
                                <FormikTextInput
                                    data={{
                                        [input.name]: {
                                            ...input
                                        }
                                    }}
                                    name={input.name}
                                    formik={formik}
                                    disabled={input.disabled}
                                    className={styles.input}
                                />
                            )
                        }
                        {
                            input.type.toLowerCase() === "select" && (
                                <FormikSelectInput
                                    data={{
                                        [input.name]: {
                                            ...input
                                        }
                                    }}
                                    name={input.name}
                                    formik={formik}
                                    disabled={input.disabled}
                                    options={input.options}
                                    optionKey={input.firstOptionKey}
                                    optionValue={input.firstOptionValue}
                                    optionName={input.firstOptionName}
                                    className={styles.input}
                                    all={input.all === false ? input.all : true}
                                    selectDefault={selectDefault}
                                    anchoInput={input.width}
                                />
                            )
                        }
                        {
                            /* Mismo rol que "select", para listas largas donde recorrer
                               un desplegable no escala. Se cambia uno por otro: el filtro
                               sigue guardando el mismo valor. */
                            input.type.toLowerCase() === "autocomplete" && (
                                <FormikAutocompleteInput
                                    data={{
                                        [input.name]: {
                                            ...input
                                        }
                                    }}
                                    name={input.name}
                                    formik={formik}
                                    disabled={input.disabled}
                                    options={input.options}
                                    optionValue={input.optionValue}
                                    optionLabel={input.optionLabel}
                                    className={styles.input}
                                    anchoInput={input.width}
                                />
                            )
                        }
                        {
                            input.type.toLowerCase() === "date" && (
                                <FormikDateInput
                                    // labelText={"Fecha Desde"}
                                    // name="fechaDesde" v
                                    type="date"
                                    variant="standard"
                                    data={{
                                        [input.name]: {
                                            ...input
                                        }
                                    }}
                                    name={input.name}
                                    formik={formik}
                                    disabled={input.disabled}
                                    className={styles.input}
                                />

                            )
                        }
                    </div>
                ))
            }
            {children}
            <HeaderButton text={"Filtrar"} type="submit" disabled={disabled} >
                <FilterAltRoundedIcon />
            </HeaderButton>
        </form>
    );
};